import { Block } from 'webiq.boilerplate'

export default class CheckoutShipping extends Block {
	static title = 'checkout-shipping'

	init() {
        this.shippingSelect = this.getElement("shipping-methods")
        this.shippingImage = this.getElement("shipping-image")

		if (this.getElement("shipping-methods")) {
            this.shippingSelect.addEventListener('sl-change', (e) => {
                const currentOption = e.currentTarget.querySelector('[aria-selected="true"]')
                this.shippingImage.src = currentOption.dataset.img

                if (e.currentTarget.value == 10) {
                    window.eventEmitter.emit("parcelshop:show")
                } else {
                    window.eventEmitter.emit("parcelshop:hide")
                }
            })
        }
	}
}
